module.exports = __webpack_public_path__ + "cartilla.png?3db8a8901ab51fb87e4232b48dd50f2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartilla.png
// module id = 670
// module chunks = 0 2 7 8 9 10